export const environment = {
  production: false,
  api_url : 'https://jowieo2zl2.execute-api.eu-west-3.amazonaws.com/qa/',
  env_prefix : 'QA'
};
